import { Policy } from "@/interfaces/policy";
import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";

interface Params {
  groupId: string | number;
}

interface Props {
  params: Params;
  immediate?: boolean;
}

const getGroupPolicies = async (param: Params): Promise<Policy[]> => {
  const { data } = await axios.get<Policy[]>(
    `api/groups/${param.groupId}/policies`,
  );
  return data;
};

const useGroupPolicies = (props: Props) => {
  const { params, immediate = true } = props || {};
  const { data, isLoading, isError, refetch } = useQuery(
    ["groupPolicies", props.params.groupId],
    () =>
      getGroupPolicies({
        groupId: params.groupId,
      }),
    {
      enabled: immediate,
    },
  );

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};

export default useGroupPolicies;
